import getStore from '../store/store';
import { DropViewState, DraggableItemTypes } from 'owa-dnd';
import { getDraggedItemType } from 'owa-module-dnd-store';
import { OwaDate } from 'owa-datetime';

export function getCalendarTabDropState(): DropViewState {
    return getStore().calendarTabDropViewState;
}

export function getTasksTabDropState(): DropViewState {
    return getStore().tasksTabDropViewState;
}

//DropViewState for the Calendar part of time panel
export function getTimePanelDropState(): DropViewState {
    return getStore().timePanelDropViewState;
}

export function getDropBoxDropState(): DropViewState {
    return getStore().dropBoxDropViewState;
}

export function shouldShowCalendarTabHoverHint(): boolean {
    return (
        getCalendarTabDropState().draggableItemType === DraggableItemTypes.MailListRow ||
        getDraggedItemType() === DraggableItemTypes.MailListRow ||
        getTimePanelDropState().draggableItemType === DraggableItemTypes.MailListRow
    );
}

export function shouldShowTasksTabHoverHint(): boolean {
    return (
        getTasksTabDropState().draggableItemType === DraggableItemTypes.MailListRow ||
        getDraggedItemType() === DraggableItemTypes.MailListRow ||
        getTimePanelDropState().draggableItemType === DraggableItemTypes.MailListRow
    );
}

export function getLastDragOverCalendarTab(): OwaDate | null {
    return getStore().lastDragOverCalendarTab;
}

export function getLastDragOverTasksTab(): OwaDate | null {
    return getStore().lastDragOverTasksTab;
}

export function isHoveringOverDayDropHint(): boolean {
    return getStore().shouldShowHoverDayDrop;
}

export function getDayViewDropTimeMinuteOffset(): number | null {
    return getStore().dayViewDropTimeMinuteOffset;
}

export function getLastDragOverUpNext(): OwaDate | null {
    return getStore().lastDragOverUpNext;
}

export function getUpNextDropState(): DropViewState {
    return getStore().upNextDropViewState;
}

export function shouldShowUpNextHoverHint(): boolean {
    return (
        getStore().upNextDropViewState &&
        (getStore().upNextDropViewState.draggableItemType === DraggableItemTypes.MailListRow ||
            getDraggedItemType() === DraggableItemTypes.MailListRow)
    );
}
